import { format } from 'date-fns';

const rentFormatDate = (dateString, dateFormat = 'dd.MM.yyyy | HH:mm') => (
  format(new Date(dateString), dateFormat)
);

export default rentFormatDate;